import React from "react";
import './PromptModal.css';
import '../../App.css';
import { Alert, Button } from "reactstrap";

export default function PromptModal({ 
  isOpen, 
  showAlert = false,
  modalTitle = "Add a New Step",
  defaultTitle = "", 
  defaultDetails = "", 
  onCancel, 
  onSubmit 
}) {
  const [title, setTitle] = React.useState(defaultTitle);
  const [details, setDetails] = React.useState(defaultDetails);

  // Reset state when props or isOpen changes
  React.useEffect(() => {
    setTitle(defaultTitle);
    setDetails(defaultDetails);
  }, [defaultTitle, defaultDetails, isOpen]);

  console.log("rendering PromptModal, with isOpen:[", isOpen, "] modalTitle:[", modalTitle, "] title:[", title, "] details:[", details, "]" );

  if (!isOpen) return null;
  return (
    <div className="prompt-modal-overlay">
      <div className="prompt-modal">
        <h3>{modalTitle}</h3>
        {showAlert && <Alert color="warning" style={{ fontSize: '.75em' }}>
          In most cases, we recommend that trainings are constrained to 5 steps or less. Adding more steps may reduce the effectiveness of your training.
        </Alert>}

        <input
          type="text"
          placeholder="Step title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          placeholder="Sub steps / details"
          rows={4}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        />

        <div className="prompt-modal-actions">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            className="btn-primary"
            onClick={() => {
              onSubmit({ title, details });
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}
